// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import barChart10Icon from "@/assets/icons/bar-chart-10.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type BarChart10IconProps = Omit<IconProps, "name">;

export function BarChart10Icon(props: BarChart10IconProps): React.ReactNode {
  return <Icon name={barChart10Icon} {...props} />;
}
